import { useState } from "react";

interface LockerProps extends DarkMode {
  isClosed: boolean;
  setClosed: SetBoolean;
}

export default function Locker({ isDark, isClosed, setClosed }: LockerProps) {
  const [height, setHeight] = useState("100vh");
  const [startPosition, setStartPosition] = useState(0);
  const [isDraggable, setDraggable] = useState(false);

  const getCurrentPosition = (event: React.TouchEvent | React.MouseEvent) => {
    if ("touches" in event && event.touches.length > 0) {
      return event.touches[0].clientY;
    } else {
      return (event as React.MouseEvent).clientY;
    }
  };

  const handleMove = (event: React.TouchEvent | React.MouseEvent) => {
    if (isDraggable) {
      const position = getCurrentPosition(event);
      setHeight(`${position}px`);
      if (startPosition - position > 300) {
        setClosed(true);
      }
    }
  };

  const returnHeight = (event: React.TouchEvent | React.MouseEvent) => {
    if (isDraggable) {
      const position = getCurrentPosition(event);
      const needClose = startPosition - position >= 300;
      setHeight(needClose ? "0px" : "100vh");
      setClosed(needClose);
    } else {
      setHeight("100vh");
    }
    setDraggable(false);
  };

  if (isClosed) return null;

  return (
    <div
      className={`w-screen h-screen ${isDark ? "bg-slate-900" : "bg-red-200"}`}
      onMouseUp={(event) => {
        returnHeight(event);
      }}
      onTouchEnd={(event) => returnHeight(event)}
    >
      <div
        className="flex flex-col items-center justify-between pb-32"
        style={{ height: height }}
      >
        <div className="flex h-full justify-center items-center">
          <img
            src="/header/logo.png"
            alt="logo"
            width={window.innerWidth > window.innerHeight ? "40%" : "80%"}
          />
        </div>
        <button
          className={`rounded-xl ${
            isDark
              ? "bg-gray-700 hover:bg-gray-800"
              : "bg-gray-100 hover:bg-white"
          } px-2 py-1`}
          onTouchStart={(event) => {
            setDraggable(true);
            setStartPosition(event.touches[0].clientY);
          }}
          onTouchMove={(event) => handleMove(event)}
          onTouchEnd={(event) => {
            returnHeight(event);
          }}
          onMouseDown={(event) => {
            setDraggable(true);
            setStartPosition(event.clientY);
          }}
          onMouseMove={(event) => handleMove(event)}
        >
          Потянуть
        </button>
      </div>
    </div>
  );
}
